import React from "react";
import { Check } from "@phosphor-icons/react";

export default function MaterialSelector({ materials, selectedId, onSelect }) {
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="material-selector">
      {materials.map((m) => {
        const active = m.id === selectedId;
        return (
          <button
            key={m.id}
            data-testid={`material-card-${m.id}`}
            onClick={() => onSelect(m.id)}
            className={`group relative overflow-hidden border text-left transition-all duration-200 ${
              active
                ? "border-[#EF233C] shadow-[0_0_0_1px_#EF233C,0_4px_20px_rgba(239,35,60,0.18)]"
                : "border-zinc-200 hover:border-zinc-400"
            }`}
          >
            <div
              className={`h-20 bg-cover bg-center transition-all duration-300 ${
                active ? "" : "grayscale opacity-70 group-hover:opacity-90"
              }`}
              style={{ backgroundImage: `url(${m.texture_url})` }}
            />
            {active && (
              <div className="absolute top-2 right-2 bg-[#EF233C] p-1">
                <Check weight="bold" size={14} className="text-white" />
              </div>
            )}
            <div className="p-3 bg-white">
              <p className="font-semibold text-sm leading-tight text-zinc-900">{m.name}</p>
              <p className="text-xs text-zinc-500 mt-0.5">{m.description}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
